import { toast } from 'react-toastify';
import appApi from '../../../../api/app-api';
import { ProfessorsSalariesStatusesType } from '../../../../api/types/accountants/salaries-statuses/professors-salaries-statuses.type';

export const retrieveEmployeeSalaryPaymentStatusOperation = async (
  startDate: Date,
  endDate: Date,
  includeHistoricalMissingPayments: boolean,
  setLoading: (loading: boolean) => any,
  setData: (data: ProfessorsSalariesStatusesType) => any,
) => {
  try {
    setLoading(true);

    // Call the API with the date parameters
    const res = await appApi.retrieveEmployeeSalaryStatus(
      startDate,
      endDate,
      includeHistoricalMissingPayments,
    );
    setData(res.data.body);
    setLoading(false);
  } catch (e) {
    setLoading(false);
    toast.error('משהו קרה, יש לנסות שוב בעוד מספר רגעים...');
  }
};
